import { Fade, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import MenuIcon from "@mui/icons-material/Menu";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useNavigate } from "react-router-dom";

function TemplateActions({
  template,
  setTemplate,
  openRenameModal,
  deleteTemplate,
  openAssignModal,
  generateReport,
  hideActions,
  displayGenerateReport,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleTemplateRename = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    setTemplate(template.id);
    openRenameModal(true);
  };

  const handleTemplateAssign = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    setTemplate(template.id);
    openAssignModal(true);
  };

  const handleTemplateDelete = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    deleteTemplate(template.id);
  };

  const handleTemplateEdit = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    navigate(`/coach/templates/edit/${template.id}`);
  };

  const handleTemplateCopy = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    navigate(`/coach/templates/copy/${template.id}`);
  };

  const handleReportGenerate = (event) => {
    event.stopPropagation();
    event.preventDefault();
    generateReport(template.id);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton sx={{ p: 0 }} onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        {!hideActions && (
          <MenuItem onClick={handleTemplateEdit}>
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              Edit
            </ListItemText>
          </MenuItem>
        )}
        {!hideActions && (
          <MenuItem onClick={handleTemplateRename}>
            <ListItemIcon>
              <DriveFileRenameOutlineIcon />
            </ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              Rename
            </ListItemText>
          </MenuItem>
        )}
        {!hideActions && (
          <MenuItem onClick={handleTemplateAssign}>
            <ListItemIcon>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              Assign
            </ListItemText>
          </MenuItem>
        )}
        <MenuItem onClick={handleTemplateCopy}>
          <ListItemIcon>
            <ContentCopyIcon />
          </ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
            Make a Copy
          </ListItemText>
        </MenuItem>
        {!hideActions && (
          <MenuItem onClick={handleTemplateDelete}>
            <ListItemIcon>
              <DeleteForeverIcon />
            </ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              Remove
            </ListItemText>
          </MenuItem>
        )}
        {!hideActions && displayGenerateReport && (
          <MenuItem onClick={handleReportGenerate}>
            <ListItemIcon>
              <FilterNoneIcon />
            </ListItemIcon>
            <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
              Generate now
            </ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
}

export default TemplateActions;
